var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/Check.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from check.svg
 */
export default function CheckIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "CheckIcon",
    ...props,
    children: _jsxDEV("g", {
      "fill-rule": "evenodd",
      children: [_jsxDEV("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        fill: "currentColor",
        d: "M12.18 2.427a1 1 0 0 1 1.705 1.04l-.066.106-7 10a1 1 0 0 1-1.606.045l-.07-.104-3-5A1 1 0 0 1 3.792 7.39l.065.097 2.207 3.677z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=Check.js.map